import apiClient from '@/axios';


export async function getAllOrders() {
    return apiClient.get("/admin/get/support/orders");
  }

  export async function refundOrderById(orderId, orderType) {
    return apiClient.post(`/admin/orders/${orderId}/cancel/${orderType}`);
  }